export const UPDATE_MAINTENANCE = 'update_maintenance';
export const UPDATE_ADVANCED_CONFIG = 'update_advance_config';
export const UPDATE_ELASTIC_CONFIG = 'update_elastic_config';
export const UPDATE_NODES_SPECIFIC_CONFIG = 'update_nodes_specific_config';
